import { PolicyChangeAction, PolicyChangeStatus } from '@/models/policyChange'
import { LoadedPolicyChange } from './LoadedPolicyChange'
import { PolicyChangeDetail } from './PolicyChangeDetail'
import { PolicyChangeForm } from './PolicyChangeForm'

/** A draft opens in the guided form; anything else, including a request sent back for changes, shows where it stands. */
export function PolicyChangePage() {
  return (
    <LoadedPolicyChange>
      {(request) =>
        request.status === PolicyChangeStatus.DRAFT && request.actions.includes(PolicyChangeAction.EDIT) ? (
          <PolicyChangeForm request={request} />
        ) : (
          <PolicyChangeDetail request={request} />
        )
      }
    </LoadedPolicyChange>
  )
}
